export const URL_COMPANY_PREFIX = "company"
export const URL_CONTRACTOR_PREFIX = "contractor"
export const URL_EMPLOYEE_PREFIX = "employee"
export const URL_STAFF_PREFIX = "admin"
export const URL_TM_PREFIX = "team-member"

export const URL_CURRENT_PLACEHOLDER = "current"

export const NAMESPACE_FOR_TYPE: Record<string, string> = {
  Employment: URL_EMPLOYEE_PREFIX,
  Contract: URL_CONTRACTOR_PREFIX,
  Fallback: URL_TM_PREFIX,
}
